import type { Course } from '@/types/course';

export const courses: Course[] = [
  {
    id: 'english-basics',
    title: '零基础英语口语入门',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20flat%20illustration%20of%20English%20conversation%20learning%20with%20speech%20bubbles%20and%20alphabet%20letters%20on%20a%20soft%20light%20gray%20white%20background%2C%20minimal%20educational%20poster%20style%2C%20professional%20and%20friendly%2C%20high%20detail%2C%20harmonious%20calm%20composition&width=800&height=500&seq=course-english-01&orientation=landscape',
    category: 'lang',
    categoryName: '语言学习',
    subcategory: '英语',
    level: '初级',
    duration: '12小时',
    priceType: '免费',
    price: 0,
    students: 12840,
    likes: 2340,
    rating: 4.8,
    views: 45210,
    publishedAt: '2026-09-28',
    teacher: '李婉清',
    teacherTitle: '资深英语口语讲师',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20friendly%20female%20Asian%20teacher%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20warm%20confident%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-liwanqing&orientation=squarish',
    intro: '从发音、音标到日常对话场景，带你告别哑巴英语，一年内建立开口自信。',
    outline: ['认识音标与发音规则', '日常问候与自我介绍', '购物、点餐与出行场景对话', '职场基础沟通表达', '常见口语错误纠正'],
    tags: ['口语', '零基础', '免费'],
  },
  {
    id: 'japanese-n5',
    title: '日语零基础直达 N5',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20flat%20illustration%20of%20Japanese%20language%20study%20with%20hiragana%20characters%20and%20cherry%20blossom%20accents%20on%20a%20soft%20light%20gray%20background%2C%20clean%20educational%20poster%20style%2C%20calm%20professional%20aesthetic%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-japanese-02&orientation=landscape',
    category: 'lang',
    categoryName: '语言学习',
    subcategory: '日语',
    level: '初级',
    duration: '20小时',
    priceType: '付费',
    price: 199,
    students: 6420,
    likes: 1180,
    rating: 4.7,
    views: 22190,
    publishedAt: '2026-09-20',
    teacher: '陈洛言',
    teacherTitle: '日语能力考教研组长',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20calm%20male%20Asian%20teacher%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20friendly%20composed%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-chenluoyan&orientation=squarish',
    intro: '五十音图到日常会话，循序渐进掌握 N5 全部语法与词汇，轻松入门日语。',
    outline: ['五十音图与发音', '名词句与基础助词', '动词分类与活用', '日常会话与场景表达', 'N5 真题演练'],
    tags: ['日语', 'N5', '考级'],
  },
  {
    id: 'ielts-writing',
    title: '雅思写作 7 分冲刺',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20IELTS%20academic%20writing%20with%20paper%20pen%20and%20charts%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20educational%20poster%2C%20subtle%20teal%20accents%2C%20high%20detail%20harmonious%20composition&width=800&height=500&seq=course-ielts-03&orientation=landscape',
    category: 'lang',
    categoryName: '语言学习',
    subcategory: '雅思托福',
    level: '高级',
    duration: '16小时',
    priceType: '付费',
    price: 349,
    students: 3180,
    likes: 860,
    rating: 4.9,
    views: 15640,
    publishedAt: '2026-10-02',
    teacher: '苏亦然',
    teacherTitle: '雅思写作 8.5 分持证教师',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20elegant%20female%20teacher%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20confident%20warm%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-suyiran&orientation=squarish',
    intro: '大作文与小作文结构模板 + 高分句型，配合范文精讲，帮你稳定拿到 7 分。',
    outline: ['评分标准深度解析', '小作文图表描述套路', '大作文论证结构搭建', '高分词汇与句型积累', '范文精批与实战演练'],
    tags: ['雅思', '写作', '高分'],
  },
  {
    id: 'korean-basics',
    title: '韩语发音与日常会话',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20flat%20illustration%20of%20Korean%20language%20learning%20with%20hangul%20characters%20and%20pastel%20shapes%20on%20a%20soft%20light%20gray%20background%2C%20minimal%20educational%20poster%20style%2C%20calm%20friendly%20aesthetic%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-korean-04&orientation=landscape',
    category: 'lang',
    categoryName: '语言学习',
    subcategory: '韩语',
    level: '初级',
    duration: '10小时',
    priceType: '免费',
    price: 0,
    students: 5210,
    likes: 940,
    rating: 4.6,
    views: 18320,
    publishedAt: '2026-09-12',
    teacher: '朴敏书',
    teacherTitle: '韩语母语外教',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20friendly%20female%20Korean%20teacher%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20warm%20smiling%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-parkminshu&orientation=squarish',
    intro: '从韩文字母发音开始，掌握拼读规律与高频日常会话，看懂韩剧基础台词。',
    outline: ['韩文字母与发音规则', '音变规律详解', '日常问候与自我介绍', '购物与出行会话', '追剧常用表达'],
    tags: ['韩语', '发音', '免费'],
  },
  {
    id: 'react-frontend',
    title: 'React 前端工程实战',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20flat%20illustration%20of%20web%20frontend%20development%20with%20code%20brackets%20and%20UI%20wireframes%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20tech%20poster%2C%20subtle%20blue%20accents%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-react-05&orientation=landscape',
    category: 'it',
    categoryName: 'IT技术',
    subcategory: '前端开发',
    level: '中级',
    duration: '28小时',
    priceType: '付费',
    price: 299,
    students: 7830,
    likes: 1960,
    rating: 4.9,
    views: 38450,
    publishedAt: '2026-10-05',
    teacher: '周子墨',
    teacherTitle: '一线互联网前端架构师',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20software%20engineer%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20calm%20confident%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-zhouzimo&orientation=squarish',
    intro: '组件化思维到工程化落地，带你用 React 构建可维护、高性能的现代前端应用。',
    outline: ['组件化与状态管理', 'Hooks 深入与性能优化', '路由与数据请求', '工程化与构建部署', '完整项目实战'],
    tags: ['React', '前端', '实战'],
  },
  {
    id: 'python-backend',
    title: 'Python 后端开发从入门到部署',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20Python%20backend%20development%20with%20server%20and%20database%20icons%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20tech%20poster%2C%20subtle%20teal%20accents%2C%20high%20detail%20harmonious%20composition&width=800&height=500&seq=course-python-06&orientation=landscape',
    category: 'it',
    categoryName: 'IT技术',
    subcategory: '后端开发',
    level: '中级',
    duration: '32小时',
    priceType: '付费',
    price: 329,
    students: 5960,
    likes: 1420,
    rating: 4.8,
    views: 26870,
    publishedAt: '2026-09-25',
    teacher: '吴承宇',
    teacherTitle: '资深后端开发工程师',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20male%20developer%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20friendly%20focused%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-wuchengyu&orientation=squarish',
    intro: 'Python 语法、Web 框架到数据库与部署上线，一站式打通后端开发全流程。',
    outline: ['Python 核心语法', 'Web 框架快速上手', '数据库设计与 ORM', '接口设计与鉴权', '服务器部署与运维'],
    tags: ['Python', '后端', '部署'],
  },
  {
    id: 'data-analysis',
    title: '数据分析师进阶之路',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20flat%20illustration%20of%20data%20analysis%20with%20charts%20and%20dashboard%20elements%20on%20a%20soft%20light%20gray%20white%20background%2C%20minimal%20professional%20poster%20style%2C%20subtle%20blue%20teal%20accents%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-data-07&orientation=landscape',
    category: 'it',
    categoryName: 'IT技术',
    subcategory: '数据分析',
    level: '中级',
    duration: '24小时',
    priceType: '付费',
    price: 259,
    students: 4320,
    likes: 1080,
    rating: 4.7,
    views: 19460,
    publishedAt: '2026-09-18',
    teacher: '林清和',
    teacherTitle: '数据科学团队负责人',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20data%20analyst%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20calm%20intelligent%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-linqinghe&orientation=squarish',
    intro: '从 Excel 到 SQL 与可视化，学会用数据讲故事，做出能落地的业务分析报告。',
    outline: ['分析思维与指标体系', 'SQL 数据查询实战', '数据清洗与可视化', '业务分析报告撰写', '真实案例复盘'],
    tags: ['数据分析', 'SQL', '可视化'],
  },
  {
    id: 'ai-intro',
    title: '人工智能通识与实战应用',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20flat%20illustration%20of%20artificial%20intelligence%20with%20neural%20network%20nodes%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20tech%20poster%2C%20subtle%20blue%20accents%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-ai-08&orientation=landscape',
    category: 'it',
    categoryName: 'IT技术',
    subcategory: '人工智能',
    level: '初级',
    duration: '14小时',
    priceType: '付费',
    price: 199,
    students: 6890,
    likes: 1720,
    rating: 4.8,
    views: 31240,
    publishedAt: '2026-10-08',
    teacher: '郑思远',
    teacherTitle: 'AI 应用方向研究员',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20AI%20researcher%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20thoughtful%20confident%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-zhengsy&orientation=squarish',
    intro: '理解大模型原理，掌握提示词工程与常见 AI 工具，把智能能力用进日常工作。',
    outline: ['人工智能发展脉络', '大模型工作原理入门', '提示词工程实战', 'AI 工具链应用', '行业落地案例'],
    tags: ['人工智能', '大模型', '通识'],
  },
  {
    id: 'accounting-basics',
    title: '会计基础与做账实操',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20illustration%20of%20accounting%20with%20ledger%20books%20and%20calculator%20on%20a%20soft%20light%20gray%20white%20background%2C%20professional%20educational%20poster%20style%2C%20subtle%20warm%20accents%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-accounting-09&orientation=landscape',
    category: 'finance',
    categoryName: '财经管理',
    subcategory: '会计基础',
    level: '初级',
    duration: '18小时',
    priceType: '付费',
    price: 179,
    students: 3980,
    likes: 720,
    rating: 4.6,
    views: 15230,
    publishedAt: '2026-09-15',
    teacher: '何书瑶',
    teacherTitle: '注册会计师 · 财税讲师',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20accountant%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20calm%20trustworthy%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-heshuyao&orientation=squarish',
    intro: '从会计要素到完整做账流程，零基础也能看懂报表、独立完成日常记账。',
    outline: ['会计要素与会计等式', '凭证与账簿处理', '常见业务分录实操', '三大报表解读', '税务基础常识'],
    tags: ['会计', '做账', '零基础'],
  },
  {
    id: 'stock-invest',
    title: '个人投资理财入门',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20personal%20investing%20with%20growth%20chart%20and%20coins%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20finance%20poster%2C%20subtle%20teal%20accents%2C%20high%20detail%20harmonious%20composition&width=800&height=500&seq=course-invest-10&orientation=landscape',
    category: 'finance',
    categoryName: '财经管理',
    subcategory: '金融投资',
    level: '初级',
    duration: '12小时',
    priceType: '免费',
    price: 0,
    students: 9140,
    likes: 2140,
    rating: 4.7,
    views: 36870,
    publishedAt: '2026-09-08',
    teacher: '梁致远',
    teacherTitle: '资深财富管理顾问',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20financial%20advisor%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20confident%20approachable%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-liangzy&orientation=squarish',
    intro: '建立正确的理财观，理解基金、股票与资产配置，科学规划你的第一桶金。',
    outline: ['理财认知与目标规划', '基金定投基础', '股票与风险认知', '资产配置与组合', '常见理财误区'],
    tags: ['理财', '基金', '免费'],
  },
  {
    id: 'excel-master',
    title: 'Excel 高效办公全能训练',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20flat%20illustration%20of%20spreadsheet%20productivity%20with%20grid%20and%20function%20icons%20on%20a%20soft%20light%20gray%20white%20background%2C%20minimal%20professional%20poster%20style%2C%20subtle%20teal%20accents%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-excel-11&orientation=landscape',
    category: 'career',
    categoryName: '职业技能',
    subcategory: '办公技能',
    level: '初级',
    duration: '15小时',
    priceType: '付费',
    price: 129,
    students: 11230,
    likes: 2680,
    rating: 4.8,
    views: 42610,
    publishedAt: '2026-09-30',
    teacher: '田野',
    teacherTitle: '办公效率培训讲师',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20office%20training%20instructor%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20friendly%20energetic%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-tianye&orientation=squarish',
    intro: '函数、数据透视表与图表一网打尽，让你处理报表的速度快上五倍。',
    outline: ['常用函数精讲', '数据透视表实战', '条件格式与图表', '数据清洗技巧', '自动化办公模板'],
    tags: ['Excel', '办公', '效率'],
  },
  {
    id: 'project-management',
    title: '项目管理方法论实战',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20project%20management%20with%20gantt%20chart%20and%20milestones%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20poster%20style%2C%20subtle%20blue%20accents%2C%20high%20detail%20harmonious%20composition&width=800&height=500&seq=course-pm-12&orientation=landscape',
    category: 'career',
    categoryName: '职业技能',
    subcategory: '项目管理',
    level: '高级',
    duration: '20小时',
    priceType: '付费',
    price: 289,
    students: 3420,
    likes: 890,
    rating: 4.8,
    views: 14280,
    publishedAt: '2026-09-22',
    teacher: '孟承泽',
    teacherTitle: 'PMP 认证 · 项目总监',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20project%20director%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20calm%20confident%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-mengcz&orientation=squarish',
    intro: '掌握范围、进度、风险与团队管理核心工具，把复杂项目稳稳推进到交付。',
    outline: ['项目管理全景框架', '范围与需求拆解', '进度计划与里程碑', '风险识别与应对', '团队协作与复盘'],
    tags: ['项目管理', 'PMP', '进阶'],
  },
  {
    id: 'ui-design',
    title: 'UI 设计系统与规范',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20flat%20illustration%20of%20UI%20design%20with%20interface%20cards%20and%20color%20swatches%20on%20a%20soft%20light%20gray%20white%20background%2C%20minimal%20design%20poster%20style%2C%20subtle%20warm%20accents%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-ui-13&orientation=landscape',
    category: 'design',
    categoryName: '设计创意',
    subcategory: 'UI设计',
    level: '中级',
    duration: '22小时',
    priceType: '付费',
    price: 269,
    students: 4680,
    likes: 1260,
    rating: 4.9,
    views: 20150,
    publishedAt: '2026-10-01',
    teacher: '许清欢',
    teacherTitle: '高级视觉设计师',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20UI%20designer%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20creative%20friendly%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-xuqh&orientation=squarish',
    intro: '从设计规范到组件库搭建，建立可复用的设计系统思维，让界面专业又统一。',
    outline: ['设计规范与栅格', '色彩与字体系统', '组件库搭建', '交互与动效基础', '作品集包装'],
    tags: ['UI设计', '设计系统', '规范'],
  },
  {
    id: 'video-editing',
    title: '短视频剪辑速成班',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20video%20editing%20with%20timeline%20and%20play%20button%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20poster%20style%2C%20subtle%20warm%20accents%2C%20high%20detail%20harmonious%20composition&width=800&height=500&seq=course-video-14&orientation=landscape',
    category: 'design',
    categoryName: '设计创意',
    subcategory: '视频剪辑',
    level: '初级',
    duration: '16小时',
    priceType: '付费',
    price: 159,
    students: 7240,
    likes: 1680,
    rating: 4.7,
    views: 28790,
    publishedAt: '2026-09-26',
    teacher: '白亦辰',
    teacherTitle: '短视频内容创作者',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20male%20content%20creator%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20friendly%20creative%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-baiyc&orientation=squarish',
    intro: '从剪辑软件基础到节奏、转场与配乐，快速产出有质感的短视频作品。',
    outline: ['剪辑软件基础操作', '节奏与镜头语言', '转场与特效技巧', '字幕与配乐', '爆款短视频拆解'],
    tags: ['剪辑', '短视频', '速成'],
  },
  {
    id: 'kaoyan-english',
    title: '考研英语全程系统班',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20flat%20illustration%20of%20exam%20preparation%20with%20books%20and%20checklist%20on%20a%20soft%20light%20gray%20white%20background%2C%20minimal%20educational%20poster%20style%2C%20subtle%20blue%20accents%2C%20high%20detail%20balanced%20composition&width=800&height=500&seq=course-kaoyan-15&orientation=landscape',
    category: 'exam',
    categoryName: '考试考证',
    subcategory: '考研',
    level: '高级',
    duration: '40小时',
    priceType: '付费',
    price: 399,
    students: 5210,
    likes: 1340,
    rating: 4.8,
    views: 24310,
    publishedAt: '2026-09-10',
    teacher: '顾长风',
    teacherTitle: '考研英语十年教龄教师',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20exam%20prep%20teacher%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20serious%20focused%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-gucf&orientation=squarish',
    intro: '词汇、长难句、阅读与写作全模块打通，配套真题演练，稳步冲刺高分。',
    outline: ['核心词汇记忆法', '长难句拆解训练', '阅读理解解题技巧', '写作模板与润色', '历年真题精讲'],
    tags: ['考研', '英语', '系统班'],
  },
  {
    id: 'teacher-cert',
    title: '教师资格证笔试通关',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20teacher%20certification%20exam%20with%20certificate%20and%20pencil%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20poster%20style%2C%20subtle%20teal%20accents%2C%20high%20detail%20harmonious%20composition&width=800&height=500&seq=course-teacher-16&orientation=landscape',
    category: 'exam',
    categoryName: '考试考证',
    subcategory: '教师资格',
    level: '中级',
    duration: '26小时',
    priceType: '付费',
    price: 219,
    students: 4360,
    likes: 980,
    rating: 4.7,
    views: 17860,
    publishedAt: '2026-09-05',
    teacher: '程雨桐',
    teacherTitle: '教师资格培训主讲',
    teacherAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20teacher%20trainer%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20warm%20encouraging%20expression%2C%20high%20detail%20editorial%20photography&width=200&height=200&seq=teacher-chengyt&orientation=squarish',
    intro: '综合素质与教育知识能力两科精讲，重点考点串联，助你一次通过笔试。',
    outline: ['综合素质核心考点', '教育知识与能力精讲', '材料分析题技巧', '作文与论述训练', '模拟卷实战'],
    tags: ['教师资格', '笔试', '考证'],
  },
];